import { resolveComponent as _resolveComponent, createVNode as _createVNode, unref as _unref, createTextVNode as _createTextVNode, withCtx as _withCtx, createElementVNode as _createElementVNode, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, renderList as _renderList, Fragment as _Fragment, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, normalizeClass as _normalizeClass, withModifiers as _withModifiers, Transition as _Transition } from "vue"

const _hoisted_1 = { class: "flex flex-col justify-between h-full" }
const _hoisted_2 = { class: "px-6 md:px-8 pt-6 pb-20" }
const _hoisted_3 = { class: "mt-2" }
const _hoisted_4 = {
  key: 1,
  class: "flex flex-col gap-4"
}
const _hoisted_5 = { class: "overflow-hidden bg-white rounded-md sm:rounded-lg sm:shadow border border-gray-300" }
const _hoisted_6 = { class: "block border-b border-gray-200 bg-white px-4 py-5 sm:px-6 hover:bg-gray-50" }
const _hoisted_7 = { class: "-ml-4 -mt-4 flex flex-wrap items-center justify-between sm:flex-nowrap" }
const _hoisted_8 = { class: "flex gap-2 items-center" }
const _hoisted_9 = { class: "text-lg font-semibold leading-6 text-gray-800 tracking-tight hover:underline" }
const _hoisted_10 = {
  key: 0,
  class: "text-sm text-gray-400 mt-1"
}
const _hoisted_11 = { class: "ml-4 mt-4 flex flex-shrink-0 gap-2" }
const _hoisted_12 = ["onClick"]
const _hoisted_13 = ["href"]
const _hoisted_14 = {
  role: "list",
  class: "divide-y divide-gray-200"
}
const _hoisted_15 = { class: "" }
const _hoisted_16 = { class: "px-4 py-4 sm:px-6" }
const _hoisted_17 = { class: "mt-1 text-gray-500" }
const _hoisted_18 = { key: 0 }
const _hoisted_19 = { class: "px-4 py-4 sm:px-6" }

import { Menu, MenuButton, MenuItem, MenuItems } from '@headlessui/vue'
import { ArrowUpRightIcon, ClipboardDocumentIcon, EllipsisHorizontalIcon, PencilIcon } from '@heroicons/vue/20/solid'
import { BuildingStorefrontIcon } from '@heroicons/vue/24/outline'
import { computed, ref } from 'vue'
import { useStore } from 'vuex'

import { dateObjectToServerDay, formatTimestamp } from '@/helpers/dates'
import api from '@/store/api'
import { mapRelationship, mapRelationships, mapType } from '@/store/mappers'


export default {
  __name: 'SellNeue',
  setup(__props) {

const copyFlash = ref({})

const vuexStore = useStore()

const stores = computed(() => mapType('store').sort((a, b) => a.attributes.order - b.attributes.order))

const methodActive = (store, method) => {
  const pairs = mapRelationships(store.relationships.fulfillment_method_store_pairs.data)
  return pairs.some(x => x.attributes.fulfillment_method_id.toString() === method.id)
}

const slots = store =>
  computed(() =>
    mapType('fulfillment_slot').filter(x => {
      const method = mapRelationship(x.relationships?.fulfillment_method?.data)
      if (method) return methodActive(store, method)
    })
  )

// doesn't take into account showing slots by arrival but it seems to work fine?
const slotsForDay = (store, day) =>
  slots(store).value.filter(x => x.attributes.fulfillment_date === dateObjectToServerDay(day))

const getSlots = store => days => {
  for (const day of days) {
    for (const slot of slotsForDay(store, day)) {
      vuexStore.commit('DESTROY_OBJECT', { data: slot })
    }
  }
  const from = dateObjectToServerDay(days.at(0))
  const to = dateObjectToServerDay(days.at(-1))
  return api.call(
    'GET',
    `fulfillment_slots?date_from=${from}&date_to=${to}&included=duplicator,fulfillment_availabilities`
  )
}

const isCatering = computed(() => vuexStore.getters.isCatering)
const isCateringStore = store => store.attributes?.platform === 'catering'

const copyLink = store => {
  navigator.clipboard.writeText(store.attributes.store_link)
  copyFlash.value[store.id] = true
  setTimeout(() => {
    copyFlash.value[store.id] = false
  }, 3000)
}

// sidebar already gets stores
api.call('GET', 'stores?included=fulfillment_methods,fulfillment_method_store_pairs')

return (_ctx, _cache) => {
  const _component_SecondaryTop = _resolveComponent("SecondaryTop")
  const _component_DescriptionHeader = _resolveComponent("DescriptionHeader")
  const _component_NeueButton = _resolveComponent("NeueButton")
  const _component_router_link = _resolveComponent("router-link")
  const _component_NeueWell = _resolveComponent("NeueWell")
  const _component_FulfillmentSlotCalendar = _resolveComponent("FulfillmentSlotCalendar")
  const _component_SecondaryNav = _resolveComponent("SecondaryNav")

  return (_openBlock(), _createBlock(_component_SecondaryNav, null, {
    top: _withCtx(() => [
      _createVNode(_component_SecondaryTop, { text: "Sell" })
    ]),
    main: _withCtx(() => [
      _createElementVNode("div", _hoisted_1, [
        _createElementVNode("div", _hoisted_2, [
          _createVNode(_component_DescriptionHeader, {
            name: isCatering.value ? 'Store' : 'Stores'
          }, null, 8, ["name"]),
          (!stores.value.length)
            ? (_openBlock(), _createBlock(_component_NeueWell, {
                key: 0,
                class: "text-center"
              }, {
                default: _withCtx(() => [
                  _createVNode(_unref(BuildingStorefrontIcon), { class: "mx-auto h-12 w-12 text-gray-400" }),
                  _createElementVNode("div", _hoisted_3, [
                    _createVNode(_component_router_link, { to: "/store/stores/new" }, {
                      default: _withCtx(() => [
                        _createVNode(_component_NeueButton, null, {
                          default: _withCtx(() => [...(_cache[1] || (_cache[1] = [
                            _createTextVNode("Create your first store", -1)
                          ]))]),
                          _: 1
                        })
                      ]),
                      _: 1
                    })
                  ])
                ]),
                _: 1
              }))
            : (_openBlock(), _createElementBlock("div", _hoisted_4, [
                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(stores.value, (store) => {
                  return (_openBlock(), _createElementBlock("div", _hoisted_5, [
                    _createElementVNode("div", _hoisted_6, [
                      _createElementVNode("div", _hoisted_7, [
                        _createVNode(_component_router_link, {
                          class: "ml-4 mt-4",
                          to: '/store/stores/' + store.id
                        }, {
                          default: _withCtx(() => [
                            _createElementVNode("div", _hoisted_8, [
                              _createElementVNode("h3", _hoisted_9, _toDisplayString(store.attributes.store_name), 1),
                              _createElementVNode("span", {
                                class: _normalizeClass(["px-2 text-xs leading-5 font-semibold rounded-full", 
                          store.attributes.status === 'live'
                            ? 'bg-green-100 text-green-800'
                            : 'bg-gray-100 text-gray-800'
                        ])
                              }, _toDisplayString(store.attributes.status === 'live' ? 'Active' : 'Private'), 3)
                            ]),
                            (_unref(formatTimestamp)(store.attributes.updated_at))
                              ? (_openBlock(), _createElementBlock("p", _hoisted_10, " Last updated " + _toDisplayString(_unref(formatTimestamp)(store.attributes.updated_at)), 1))
                              : _createCommentVNode("", true)
                          ]),
                          _: 2
                        }, 1032, ["to"]),
                        _createElementVNode("div", _hoisted_11, [
                          (isCateringStore(store))
                            ? (_openBlock(), _createBlock(_component_router_link, {
                                key: 0,
                                class: "hidden sm:inline-flex ml-3",
                                to: '/store/stores/' + store.id,
                                onClick: _cache[0] || (_cache[0] = _withModifiers(() => {}, ["stop"]))
                              }, {
                                default: _withCtx(() => [
                                  _createVNode(_component_NeueButton, { type: "secondary" }, {
                                    default: _withCtx(() => [
                                      _createVNode(_unref(PencilIcon), {
                                        class: "-ml-1 mr-2 h-5 w-5",
                                        "aria-hidden": "true"
                                      }),
                                      _cache[2] || (_cache[2] = _createTextVNode(" Edit Details ", -1))
                                    ]),
                                    _: 1
                                  })
                                ]),
                                _: 1
                              }, 8, ["to"]))
                            : (_openBlock(), _createBlock(_component_NeueButton, {
                                key: 1,
                                type: "secondary",
                                class: _normalizeClass(["hidden sm:inline-flex ml-3", copyFlash.value[store.id] && '!bg-green-500 !text-white']),
                                onClick: _withModifiers($event => (copyLink(store)), ["stop"])
                              }, {
                                default: _withCtx(() => [
                                  _createVNode(_unref(ClipboardDocumentIcon), {
                                    class: "-ml-1 mr-2 h-5 w-5",
                                    "aria-hidden": "true"
                                  }),
                                  _createTextVNode(" Cop" + _toDisplayString(copyFlash.value[store.id] ? 'ied' : 'y') + " link to store ", 1)
                                ]),
                                _: 2
                              }, 1032, ["class", "onClick"])),
                          _createVNode(_unref(Menu), { as: "div" }, {
                            default: _withCtx(() => [
                              _createVNode(_unref(MenuButton), null, {
                                default: _withCtx(() => [
                                  _createVNode(_component_NeueButton, { type: "secondary" }, {
                                    default: _withCtx(() => [
                                      _createVNode(_unref(EllipsisHorizontalIcon), {
                                        class: "h-5 w-5",
                                        "aria-hidden": "true"
                                      })
                                    ]),
                                    _: 1
                                  })
                                ]),
                                _: 1
                              }),
                              _createVNode(_Transition, {
                                "enter-active-class": "transition ease-out duration-100",
                                "enter-from-class": "transform opacity-0 scale-95",
                                "enter-to-class": "transform opacity-100 scale-100",
                                "leave-active-class": "transition ease-in duration-75",
                                "leave-from-class": "transform opacity-100 scale-100",
                                "leave-to-class": "transform opacity-0 scale-95"
                              }, {
                                default: _withCtx(() => [
                                  _createVNode(_unref(MenuItems), { class: "absolute right-0 z-10 mt-2 w-56 origin-top-right py-1 rounded-md bg-white shadow-lg ring-1 ring-black ring-opacity-5 focus:outline-none" }, {
                                    default: _withCtx(() => [
                                      (isCateringStore(store))
                                        ? (_openBlock(), _createBlock(_unref(MenuItem), { key: 0 }, {
                                            default: _withCtx(({ active }) => [
                                              _createElementVNode("button", {
                                                type: "button",
                                                class: _normalizeClass([active ? 'bg-gray-100 text-gray-900' : 'text-gray-700', "group flex items-center px-4 py-2 text-sm w-full text-left"]),
                                                onClick: _withModifiers($event => (copyLink(store)), ["stop"])
                                              }, [
                                                _createVNode(_unref(ClipboardDocumentIcon), {
                                                  class: "mr-3 h-5 w-5 text-gray-700 group-hover:text-gray-900",
                                                  "aria-hidden": "true"
                                                }),
                                                _createTextVNode(" Cop" + _toDisplayString(copyFlash.value[store.id] ? 'ied' : 'y') + " link to store ", 1)
                                              ], 10, _hoisted_12)
                                            ]),
                                            _: 2
                                          }, 1024))
                                        : (_openBlock(), _createBlock(_unref(MenuItem), { key: 1 }, {
                                            default: _withCtx(({ active }) => [
                                              _createVNode(_component_router_link, {
                                                class: _normalizeClass([active ? 'bg-gray-100 text-gray-900' : 'text-gray-700', "group flex items-center px-4 py-2 text-sm w-full text-left"]),
                                                to: '/store/stores/' + store.id
                                              }, {
                                                default: _withCtx(() => [
                                                  _createVNode(_unref(PencilIcon), {
                                                    class: "mr-3 h-5 w-5 text-gray-700 group-hover:text-gray-900",
                                                    "aria-hidden": "true"
                                                  }),
                                                  _cache[3] || (_cache[3] = _createTextVNode(" Edit store ", -1))
                                                ]),
                                                _: 1
                                              }, 8, ["class", "to"])
                                            ]),
                                            _: 2
                                          }, 1024)),
                                      _createVNode(_unref(MenuItem), null, {
                                        default: _withCtx(({ active }) => [
                                          _createElementVNode("a", {
                                            href: store.attributes.store_link,
                                            target: "_blank",
                                            class: _normalizeClass([active ? 'bg-gray-100 text-gray-900' : 'text-gray-700', "group flex items-center px-4 py-2 text-sm w-full text-left"])
                                          }, [
                                            _createVNode(_unref(ArrowUpRightIcon), {
                                              class: "mr-3 h-5 w-5 text-gray-700 group-hover:text-gray-900",
                                              "aria-hidden": "true"
                                            }),
                                            _cache[4] || (_cache[4] = _createTextVNode(" Open store as customer ", -1))
                                          ], 10, _hoisted_13)
                                        ]),
                                        _: 2
                                      }, 1024)
                                    ]),
                                    _: 2
                                  }, 1024)
                                ]),
                                _: 2
                              }, 1024)
                            ]),
                            _: 2
                          }, 1024)
                        ])
                      ])
                    ]),
                    _createElementVNode("ul", _hoisted_14, [
                      _createElementVNode("li", null, [
                        _createElementVNode("div", _hoisted_15, [
                          _createElementVNode("div", _hoisted_16, [
                            _cache[5] || (_cache[5] = _createElementVNode("div", { class: "truncate text-base font-medium text-gray-600 tracking-tight" }, "Products", -1)),
                            _createElementVNode("div", _hoisted_17, _toDisplayString(store.relationships?.products?.data?.length ?? 0) + " product" + _toDisplayString((store.relationships?.products?.data?.length ?? 0) === 1 ? '' : 's'), 1)
                          ])
                        ])
                      ]),
                      (store.relationships?.fulfillment_method_store_pairs?.data?.length)
                        ? (_openBlock(), _createElementBlock("li", _hoisted_18, [
                            _createElementVNode("div", _hoisted_19, [
                              _createVNode(_component_FulfillmentSlotCalendar, {
                                slots: slots(store).value,
                                store: store,
                                onGetSlots: x => getSlots(store)(x)
                              }, null, 8, ["slots", "store", "onGetSlots"])
                            ])
                          ]))
                        : _createCommentVNode("", true)
                    ])
                  ]))
                }), 256))
              ]))
        ])
      ])
    ]),
    _: 1
  }))
}
}

}